var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal hide-footer no-stacking",
      attrs: {
        id: "DeleteAuth0AccountModal",
        "data-test-hook": "modal-title-delete-auth0-account-modal"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            { staticClass: "modal-header pb-1 pt-1 pr-0 align-items-center" },
            [
              _c(
                "h2",
                {
                  staticClass: "modal-title",
                  attrs: {
                    "data-test-hook": "modal-heading-delete-auth0-account-modal"
                  }
                },
                [
                  _c("i", {
                    staticClass: "far fa-circle-exclamation colorOrange mr-1"
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("xAreYouSureYouWantToDeleteYourAccount")) +
                      " "
                  )
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-icon-button btn-icon-button--gray",
                  attrs: {
                    "data-test-hook":
                      "x-close-button-delete-auth0-account-modal"
                  },
                  on: {
                    click: function($event) {
                      return _vm.closeModal()
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-times" })]
              )
            ]
          ),
          _c("div", { staticClass: "modal-body pb-0" }, [
            _c("div", { staticClass: "row", attrs: { "align-h": "around" } }, [
              _c(
                "div",
                {
                  staticClass: "col",
                  attrs: {
                    "data-test-hook":
                      "modal-body-text-delete-auth0-account-modal"
                  }
                },
                [
                  _c("b", { staticClass: "d-block" }, [
                    _vm._v(_vm._s(_vm.$t("xReviewTheFollowingCarefully")))
                  ]),
                  _c("b", { staticClass: "d-block mt-3 mb-1" }, [
                    _vm._v(_vm._s(_vm.$t("xAccount")))
                  ]),
                  _vm._v(
                    " " + _vm._s(_vm.$t("xYourAccountWillBeDeleted")) + " "
                  ),
                  _c("b", { staticClass: "d-block mt-1 mb-1" }, [
                    _vm._v(_vm._s(_vm.$t("xDevices")))
                  ]),
                  _vm._v(
                    " " + _vm._s(_vm.$t("xDevicesWillContinueToFunction")) + " "
                  ),
                  _c("b", { staticClass: "d-block mt-1 mb-1" }, [
                    _vm._v(_vm._s(_vm.$t("xEcobeeHomesAndSharing")))
                  ]),
                  _vm._v(" " + _vm._s(_vm.$t("xHomeWillBeRemoved")) + " "),
                  _c("b", { staticClass: "d-block mt-1 mb-1" }, [
                    _vm._v(_vm._s(_vm.$t("xDataAndHistory")))
                  ]),
                  _vm._v(" " + _vm._s(_vm.$t("xDataWillBeDeleted")) + " "),
                  _c("b", { staticClass: "d-block mt-1 mb-1" }, [
                    _vm._v(_vm._s(_vm.$t("xSubscriptions")))
                  ]),
                  _vm._v(
                    " " + _vm._s(_vm.$t("xSubscriptionsWillBeCancelled")) + " "
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "d-block mt-4 mb-4",
                      attrs: {
                        href:
                          "https://support.generac.com/mobilelink/s/article/How-do-I-delete-my-Mobile-Link-account",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "data-test-hook":
                          "modal-learn-more-link-delete-auth0-account-modal"
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.$t("xLearnMore")) + " "),
                      _c("i", { staticClass: "fas fa-external-link-alt" })
                    ]
                  )
                ]
              )
            ])
          ]),
          _c("div", { staticClass: "modal-footer d-flex mt-2 p-0" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary my-3 ml-3",
                staticStyle: { flex: "1 1 0" },
                attrs: {
                  type: "button",
                  "data-test-hook": "cancel-button-delete-auth0-account-modal"
                },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("xCancel")) + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary my-3 mr-3",
                staticStyle: { flex: "1 1 0" },
                attrs: {
                  "data-test-hook": "continue-button-delete-auth0-account-modal"
                },
                on: {
                  click: function($event) {
                    return _vm.continueDeleteAccount()
                  }
                }
              },
              [
                _vm._v(" " + _vm._s(_vm.$t("xContinue")) + " "),
                _c("i", { staticClass: "fas fa-arrow-right fa-lg" })
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }